import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/srv/gentletales/next-app/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/srv/gentletales/src/index.css");
